var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "render-post hide-scrollbar render-post-youtube",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _vm.medias.length && _vm.medias.find((m) => m.info.type2 == "video")
        ? _vm._l(
            _vm.medias
              .filter((m) => m.info.type.startsWith("video/"))
              .slice(0, 1),
            function (media) {
              return _c(
                "div",
                { key: media.id, staticClass: "post-medias media" },
                [
                  _c("div", { staticClass: "media" }, [
                    _c("video", {
                      attrs: {
                        autoplay: _vm.autoplayVideo,
                        muted: "",
                        loop: "",
                        playsinline: "",
                        preload: "metadata",
                        src: media.url,
                        type: media.info.type,
                        onloadedmetadata: "this.muted = true",
                      },
                      domProps: { muted: true },
                    }),
                  ]),
                ]
              )
            }
          )
        : _c("div", { staticClass: "post-empty" }),
      _c(
        "div",
        { staticClass: "post-content hide-scrollbar" },
        [
          _c("div", { staticClass: "post-title" }, [
            _vm.title
              ? _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.titleTranslateMentionAndHastag),
                  },
                })
              : _c("p", [_vm._v("Unknown")]),
          ]),
          _c("div", { staticClass: "post-date" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.datePost ? _vm.formatDatePost : "A l'instant")),
            ]),
          ]),
          _c("div", { staticClass: "post-author" }, [
            _c(
              "div",
              { staticClass: "img-pages" },
              [
                _vm._l(
                  _vm.pages.slice(0, _vm.pages.length == 4 ? 4 : 3),
                  function (page, index) {
                    return [
                      _c(
                        "Tooltip",
                        {
                          key: index,
                          attrs: {
                            active: page.iconEdited,
                            text: "Voir les modifications apportées",
                            position: "right",
                            classCustom: `page ${
                              page.iconEdited ? "iconEdited" : ""
                            }`,
                          },
                          on: {
                            click: () => {
                              page.iconEdited
                                ? _vm.$emit("clickPage", page.id)
                                : _vm.openYoutubePage(page)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src:
                                page && page.avatar
                                  ? page.avatar
                                  : "img/avatar.jpg",
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]
                  }
                ),
                _vm.pages.length > 4
                  ? _c("div", { staticClass: "page count" }, [
                      _vm._v(
                        "\n                    +" +
                          _vm._s(_vm.pages.length - 3) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
            _vm.pages.length <= 1
              ? _c(
                  "p",
                  {
                    staticClass: "name",
                    on: {
                      click: function ($event) {
                        return _vm.openYoutubePage(_vm.pages[0])
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.pages[0].name))]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "bar-action" }, [
            _c("div", { staticClass: "like" }, [
              _c(
                "svg",
                {
                  staticStyle: {
                    "pointer-events": "none",
                    display: "inherit",
                    width: "100%",
                    height: "100%",
                    transform: "rotate(180deg)",
                  },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24",
                    focusable: "false",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M17,4h-1H6.57C5.5,4,4.59,4.67,4.38,5.61l-1.34,6C2.77,12.85,3.82,14,5.23,14h4.23l-1.52,4.94C7.62,19.97,8.46,21,9.62,21 c0.58,0,1.14-0.24,1.52-0.65L17,14h4V4H17z M10.4,19.67C10.21,19.88,9.92,20,9.62,20c-0.26,0-0.5-0.11-0.63-0.3 c-0.07-0.1-0.15-0.26-0.09-0.47l1.52-4.94l0.4-1.29H9.46H5.23c-0.41,0-0.8-0.17-1.03-0.46c-0.12-0.15-0.25-0.4-0.18-0.72l1.34-6 C5.46,5.35,5.97,5,6.57,5H16v8.61L10.4,19.67z M20,13h-3V5h3V13z",
                    },
                  }),
                ]
              ),
              _c("div", { staticClass: "bar" }),
              _c(
                "svg",
                {
                  staticStyle: {
                    "pointer-events": "none",
                    display: "inherit",
                    width: "100%",
                    height: "100%",
                  },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24",
                    focusable: "false",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M17,4h-1H6.57C5.5,4,4.59,4.67,4.38,5.61l-1.34,6C2.77,12.85,3.82,14,5.23,14h4.23l-1.52,4.94C7.62,19.97,8.46,21,9.62,21 c0.58,0,1.14-0.24,1.52-0.65L17,14h4V4H17z M10.4,19.67C10.21,19.88,9.92,20,9.62,20c-0.26,0-0.5-0.11-0.63-0.3 c-0.07-0.1-0.15-0.26-0.09-0.47l1.52-4.94l0.4-1.29H9.46H5.23c-0.41,0-0.8-0.17-1.03-0.46c-0.12-0.15-0.25-0.4-0.18-0.72l1.34-6 C5.46,5.35,5.97,5,6.57,5H16v8.61L10.4,19.67z M20,13h-3V5h3V13z",
                    },
                  }),
                ]
              ),
            ]),
            _c("div", { staticClass: "share" }, [
              _c(
                "svg",
                {
                  staticStyle: {
                    "pointer-events": "none",
                    display: "inherit",
                    width: "100%",
                    height: "100%",
                  },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24",
                    focusable: "false",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M15 5.63 20.66 12 15 18.37V14h-1c-3.96 0-7.14 1-9.75 3.09 1.84-4.07 5.11-6.4 9.89-7.1l.86-.13V5.63M14 3v6C6.22 10.13 3.11 15.33 2 21c2.78-3.97 6.44-6 12-6v6l8-9-8-9z",
                    },
                  }),
                ]
              ),
              _c("p", [_vm._v("Partager")]),
            ]),
          ]),
          _c("div", { staticClass: "description" }, [
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.textTranslateMentionAndHastag),
              },
            }),
          ]),
          _vm._l(_vm.comments, function (comment) {
            return _c("div", { staticClass: "comments" }, [
              _c("h5", [_vm._v("Commentaires")]),
              _c("div", { staticClass: "comment" }, [
                _c("img", {
                  attrs: {
                    src:
                      !_vm.pages ||
                      !_vm.pages.length ||
                      _vm.pages.length > 1 ||
                      !_vm.pages[0]
                        ? "img/avatar.jpg"
                        : _vm.pages[0].avatar,
                    alt: "",
                  },
                }),
                _c("p", { domProps: { innerHTML: _vm._s(comment) } }),
              ]),
            ])
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }